import { ContactSlugEnum } from '@systemeio/types'

export const STANDARD_CONTACT_SLUGS: string[] = Object.values(ContactSlugEnum)

export const isStandardContactSlug = (slug: string): boolean =>
  STANDARD_CONTACT_SLUGS.includes(slug)
